var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.showAsLink)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.goToLogin}},[_vm._v(_vm._s(_vm.prompt)+" »")]):_vm._e(),_vm._v(" "),(_vm.showAsLink)?_c('a',{attrs:{"href":"","title":_vm.prompt},on:{"click":_vm.goToLogin}},[_vm._v(_vm._s(_vm.prompt))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3823a3c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginControl.vue
// module id = null
// module chunks = 